import logoSvg from './logo.svg'

import consorcioLogoSvg from './consorcioLogo.svg'

export const SvgImageParceirosXPLogo = ( props ) => {
    return (
        <img
            className='w-full'
            width="50px"
            height="50px"
            src={logoSvg}
            alt={''}
            {...props}
        />
    )
}

export const SvgImageParceirosXPConsorcioLogo = ( props ) => {
    return (
        <img
            className='w-full'
            width="50px"
            height="50px"
            src={consorcioLogoSvg}
            alt={''}
            {...props}
        />
    )
}